import React from 'react';
import cn from 'classnames';
import RadioItem from '../radioItem';
import { Visibility, Option } from '../../../types/common-types';
import { bbCodeToHtml } from '../../../utils/formUtils';
import './style.scss';

interface RadioProps {
  id?: string;
  error?: boolean;
  label?: string;
  required?: boolean;
  value?: string;
  visibility?: Visibility;
  options: Option[];
  className?: string;
  styleName?: string;
  helperText?: string;
  align?: string;
  onChange: (value: { id: string; value: string; error: boolean }) => void;
}

const Radio: React.FC<RadioProps> = ({
  id = '',
  error = false,
  visibility = Visibility.Visible,
  options,
  value,
  label,
  onChange,
  align,
  className,
  helperText,
}) => {
  const handleChange = (val: string) => {
    if (visibility === Visibility.Disabled) return;
    onChange({ id, value: val, error: false });
  };
  const renderItems = () => {
    return options.map(opt => (
      <RadioItem
        key={opt.value}
        label={opt.title}
        visibility={opt.visibility}
        activeItem={value}
        value={opt.value}
        onClick={handleChange}
      />
    ));
  };
  return (
    <div
      id={id}
      className={className}
      data-cy="radio"
      styleName={cn('radio', {
        disabled: visibility === Visibility.Disabled,
        hidden: visibility === Visibility.Hidden,
        error,
        horizontal: align === 'horizontal',
      })}
    >
      {label && (
        <div
          styleName={cn('radio__label')} // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: bbCodeToHtml(label),
          }}
        />
      )}
      <div styleName={cn('radio__items')}>{renderItems()}</div>
      {helperText && (
        <div data-cy-prop="errorMsg" styleName={cn('radio__helperText')}>
          {helperText}
        </div>
      )}
    </div>
  );
};

export default Radio;
